module.exports = __webpack_public_path__ + "img/list_Character_fluid_02.784f5a77.jpeg";